import React, { useState } from 'react';
import ShareDialog from '.';

function useShareDialog() {
    const [open, setOpen] = useState(false);

    function openShareDialog() {
        setOpen(true);
    }

    function closeShareDialog() {
        setOpen(false);
    }

    function renderShareDialog() {
        return (
            <ShareDialog
                open={open}
                onClose={closeShareDialog}
            />
        );
    }

    return {
        openShareDialog,
        renderShareDialog,
    };
}

export default useShareDialog;
